import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div className="min-h-screen bg-[#0f0f0f] flex flex-col items-center justify-center text-white px-4 text-center">
      <h1 className="text-9xl font-bold text-yellow-300 mb-4 animate-bounce">404</h1>
      <h2 className="text-2xl font-semibold mb-2">Không tìm thấy trang !</h2>
      <p className="text-gray-400 mb-6">
        Có thể đường dẫn đã bị thay đổi hoặc không tồn tại.
      </p>
      <Link
        to="/"
        className="inline-block bg-yellow-300 text-black font-semibold py-4 px-6 rounded-full transition duration-200"
      >
        Quay về Trang chủ
      </Link>
    </div>
  );
};

export default NotFound;
